<template>
    <div>
        {{showClosePopUp}}{{showCloseEditPopUp}}{{getInvestigationId}}
        <div v-if="show_modal">
            <transition name="modal">
              <div class="modalhold">
                <div class="modal-mask upl-hold" style="overflow-y: auto; display: block;">
                    <div class="modal-wrapper">
                        <div class="modal-container wider-midB clinicalnote upload-reports-section">
                            <div class="section-loader prescription-popup" v-if="showloader">
                              <img src="../../static/images/loader-icon.png" id="loading"> 
                            </div>
                            <!--Modal header-->
                            <div class="modal-headers pb-0 border-bottom-0 pt-0">
                                <!-- <slot name="header" style="border:1px red;">
                                    <h5 class="modal-title mb-0">Upload report</h5>
                                    <button
                                        type="button"
                                        aria-label="Close"
                                        class="close up-close"
                                        @click.prevent="closePopUp('goBack')"
                                        >×</button>
                                </slot> -->
                                <div class="ehr-popup-header-colored popup-header-blue">
                                  <div class="ehr-popup-title">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"
                                      stroke-linejoin="round" style="width:18px;height:18px;">
                                    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                    <polyline points="2 17 12 22 22 17"></polyline>
                                    <polyline points="2 12 12 17 22 12"></polyline>
                                    </svg>
                                      Upload report
                                  </div>
                                    <button type="button"
                                     aria-label="Close"
                                     class="ehr-popup-close" @click.prevent="closePopUp('goBack')"
                                    >×</button>
                                </div>
                            </div>
                            <!--Modal Body-->
                            <div class="col-md-12  ">
                                <div class="layout_2">
                                    <slot name="body">
                                        
                                        <div class="upload-outer">
                                            <div class="row"  :class="show_add_diatgnosticCenter?'mart-50':' '">
                                                
                                                <div  class="row choose-select-hold">
                                                    <div class="col-md-12  px-0">
                                                      <div class="col-md-12  px-0 text-center file-detail-hold">
                                                          <div class="pull-left tags-hold w-100 ">
                                                              <ul class="list">
                                                                  <li data-toggle="tooltip" :title="item.name"   v-for="item in selectedFiles">
                                                                    <!-- testfile.jpg -->
                                                                    {{item.name}}
                                                                    <a href="javascript:void(0);" @click.prevent="removeFile(item)">×</a>
                                                                  </li>
                                                              </ul>
                                                          </div>
                                                          <div class="file-upload btn btn-default text-center" v-if="filecountcanbeuploaded">
                                                              <span>{{browseBtnTxt}}</span>
                                                              <input class="upload"
                                                                  ref="upload"
                                                                  type="file"
                                                                  id="uploadFile1"
                                                                  name="uploadFile"
                                                                  accept="image/*, application/pdf"
                                                                  @change="validateFile()"
                                                                  @click="resetFile()"
                                                                  multiple>
                                                          </div>
                                                          <div class="file-upload ml-3" v-else>
                                                            <div v-if="filescanbeuploaded==0" class="alert-red1 L-inline text-center">
                                                              <p class="mb-0">You have already uploaded maximum number of files allowed.</p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                         <!-- <div class="analysize-loading">
                                                          
                                                          <div class="uploaded">Uploaded</div>
                                                          <div class="loader-line"></div>
                                                          <div class="report">Report</div>
                                    
                                                        </div>  -->
                                                        <div class="info-upload-i">
                                                          <span class="d-block ml-3 mb-2">png, jpeg, webp and pdf <span > No bigger than {{((gett_allowedFileSize)/1024)/1024}}MB</span>
                                                          </span>
                                                          <span class="d-block" v-if="!validFileExt && !validFileSize" :style="(!validFileExt && !validFileSize)?'margin-left: -28px;':''">
                                                            <span class="info-upload-mail">Invalid file size. Maximum {{((gett_allowedFileSize)/1024)/1024}}MB size allowed</span>
                                                          </span>
                                                          <span class="d-block" v-else-if="!validFileExt" :style="(!validFileExt)?'margin-left: -28px;':''">
                                                            <span class="info-upload-mail">Invalid file type</span>
                                                          </span>
                                                          <span class="d-block" v-else-if="!validFileSize" :style="(!validFileSize)?'margin-left: -28px;':''">
                                                            <span class="info-upload-mail">Selected file size is invalid</span>
                                                          </span>
                                                          <span class="d-block" v-else-if="!validFileCount" :style="(!validFileCount)?'margin-left: -28px;':''">
                                                            <span class="info-upload-mail error-info">Max of {{filescanbeuploaded}} files allowed</span>
                                                          </span>
                                                        </div>
                                                    </div>
                                                </div>
                                             
                                                <!-- <div class="row" style="margin-top:0px;">
                                                    <div class="col-md-12 mt-3">
                                                        <div class="form-group mb-0">
                                                            <div class="container-TXT">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <div class="row wd-100 mt-0 model-foot">
                                                    <div class="col-md-12 padr-0">
                                                        <button @click.prevent="SaveReport(false,false)" class="av-btn-primary pull-right ripple">Save & close</button>
                                                        <!-- <button data-toggle="modal" data-target="#analysize" class="primary-btn pull-right ripple">Analysize</button> -->
                                                        <button @click.prevent="closePopUp('goBack')" class="av-btn-ghost pull-right ripple pdr-r10">Back</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- row -->
                                        </div>
                                      </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </transition>
        </div>
        <div v-if="updateModal">
            <transition name="modal">
                <div class="modal-mask upl-hold">
                    <div class="modal-wrapper">
                        <div class="modal-container wider-midB">
                            <!--Modal header-->
                            <div class="modal-header">
                                <slot name="header" style="border:1px red;">
                                    <h5 class="modal-title mt-3">Update web report</h5>
                                    <button
                                        type="button"
                                        aria-label="Close"
                                        class="close up-close"
                                        @click.prevent="closePopUp('goBack')"
                                        >×</button>
                                </slot>
                            </div>
                            <!--Modal Body-->
                            <div class="modal-body">
                                <div class="layout_2">
                                    <slot name="body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="container-comm">
                                                        <span class="pdr-12">{{selected_report_type.report_type}}</span>
                                                        <!-- <input type="text" autocomplete="off" v-model="selected_report_type.report_type" class="pdr-12" name="uname" title="" required=""> -->
                                                        <label for="days" class="valid">
                                                        <b>Report type</b>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="container-comm">
                                                        <span class="pdr-12">{{selected_test_type.test_name}}</span>
                                                        <!-- <input type="text" autocomplete="off" v-model="selected_report_type.report_type" class="pdr-12" name="uname" title="" required=""> -->
                                                        <label for="days" class="valid">
                                                        <b>Test type</b>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                              <div class="row mb-3 mt-2">
                                      <div class="col-md-3">
                                        <a @click.prevent="showHideNote()" href="javascript:void(0);" class="add-new-btn addnote-inline" id="add_category" style="float: initial;">
                                          Add note
                                          <i class="material-icons">add</i>
                                        </a>
													            </div>
                                      <div class="col-md-12 ">
                                        <div class=" clr-bothmr">
                                          <div class="col-md-12 mt-2 pl-0 pr-0">
                                          <div v-if="showNote" style="">
                                            <div class="form-group mb-0">
                                              <!-- <div class="text-2000">10/250</div> -->
                                              <div class="container-TXT">
                                                <textarea v-if="selected_report_type && selected_report_type.report_type && selected_test_type && selected_test_type.test_name"
                                                  @input="countChar" v-model="report_notes" rows="4" autocomplete="off" name="uname" title="" required=""></textarea>
                                                
                                                <label for="fname"><b>Note </b></label>
                                              </div>
                                              <div class="text-2000">{{report_notes.length+'/'+totalcharallowedfornote}}</div>
                                            </div>
                                          </div>
                                          </div>
                                        </div>
                                      </div>
                              </div>


                                        <div class="upload-outer">
                                            <div class="row">
                                                <div class="web-repo-hold" v-if="selected_reportSubmitMethod==='_web' && webReportDetailsArr && webReportDetailsArr.length">
												<div id="weburlsection" v-for="(item,index) in webReportDetailsArr">
                                                    <!-- Diagnostics Center Name -->
                                                    <div class="row mb-3">
                                                      <div class="col-md-12">
                                                        <div class="form-group">
                                                          <div class="container-comm">
                                                            <div class="select">
                                                              <select
                                                                v-model="item.selectedDiagCenter"
                                                                @change="getIndexedSelectedDiagnosticCenter(item, index)"
                                                                class="select-text show-first"
                                                                title
                                                                required
                                                              >
                                                                <option selected value="OTHERS">Others</option>
                                                                <option v-for="diag in finalDiagnosticList" v-bind:value="diag.unique_id">{{diag.name}}</option>
                                                              </select>
                                                              <label class="select-label">Diagnostic centre name</label>
                                                              <button
                                                                @click.prevent="show_add_indexed_diatgnosticCenter_part(item,index)"
                                                                title
                                                                data-toggle="tooltip"
                                                                class="primary-btn add-category-btn add-dcn"
                                                                data-original-title
                                                                v-if="item.showAddDiagBtn">
                                                                <span v-if="item.show_add_diatgnosticCenter">-</span>
                                                                <span v-else>+</span>
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row">
                                                      <div class="col-md-12 mt-3 mb-3" v-if="item.show_add_diatgnosticCenter">
                                                        <div class="form-group">
                                                          <div class="container-comm">
                                                            <div
                                                              v-if="item.show_add_diatgnosticCenter"
                                                              class=""
                                                              >
                                                              <div class="" style="">
                                                                  <div class="">
                                                                      <div class="" style="margin-bottom:10px;">
                                                                          <div class="">
                                                                              <input type="text" v-model="selectedDiagCenterTemp" autocomplete="off" name="uname" required>
                                                                              <label for="email">
                                                                              <b class="btn-HS">Enter diagnostic centre name</b>
                                                                              </label>
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                                  <div class="col-lg-12 pr-0">
                                                                      <div class="pull-right">
                                                                          <a
                                                                            @click.prevent="addIndexedDiagnostic(item,selectedDiagCenterTemp)"
                                                                            href="javascript:void(0);"
                                                                            class="primary-btn ripple btn-HS save-category"
                                                                            >Save</a>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

													                          <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <div class="container-comm">
                                                                    <input type="text"
                                                                        :disabled="!selected_reportSubmitMethod==='_web'"
                                                                        id="reportWebsiteUrlId"
                                                                        v-model="item.reportWebsiteUrl"
																	                                        	@input=validateField(item,index)
                                                                        autocomplete="off" class="pdr-12" name="uname" title="" required="">
                                                                    <label for="days"><b>Enter website</b></label>
                                                                    <div class="info-upload"
                                                                        v-if="!item.validWebsiteUrl"
                                                                        style="color: #AA0000;"
                                                                        >Please enter a valid website.Example: https://www.google.com</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <div class="container-comm">
                                                                    <input type="text"
                                                                        :disabled="!(selected_reportSubmitMethod==='_web' && item.reportWebsiteUrl != '' && item.validWebsiteUrl)"
                                                                        id="reportWebsiteUserId"
                                                                        v-model="item.reportWebsiteUname"
                                                                        class="pdr-12"
                                                                        name="uname">
                                                                    <label for="days"><b>User name</b></label>
                                                                </div>
                                                                <!-- <span
                                                                    v-if="!validWebUserName"
                                                                    style="color: #AA0000;"
                                                                    >Minimum 3 characters required</span> -->
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <div class="container-comm">
                                                                    <input
                                                                        :disabled="!(selected_reportSubmitMethod==='_web' && item.reportWebsiteUrl != '' && item.reportWebsiteUname != '')"
                                                                        type="text"
                                                                        id="reportWebsitePassId"
                                                                        v-model=item.reportWebsitePass
                                                                        autocomplete="off" class="pdr-12" name="editpass" title="" required="">
                                                                    <label for="editpass"><b>Password</b></label>
                                                                </div>
                                                                <!-- <span
                                                                    v-if="!validWebUserPass"
                                                                    style="color: #AA0000;"
                                                                    >Minimum 1 characters required</span> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
												  <div class="row" style="margin-top:0px;">
                              <div class="col-md-12 mt-3">
                                  <div class="form-group mb-0">
                                      <div class="container-TXT">
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="row wd-100 mt-0">
													

													<div class="col-md-12 padr-0">
														<button @click.prevent="SaveReport(false,true)" class="primary-btn pull-right ripple">Save & close</button>
														<button @click.prevent="closePopUp('goBack')" class="secondary-btn pull-right ripple pdr-r10">Back</button>
													</div>
                                                </div>
                                            </div>
                                            <!-- row -->
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <transition name="fade">
            <Messages v-if="isdisplaymsg" :iserror="iserrormsg" :datamessage="sucessmsgtext" v-on:closemsg="closeMessage" v-bind:isVisible="isdisplaymsg"></Messages>
        </transition>



<!-- Modal -->
<div class="modal fade analysize" id="analysize" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content p-0">
      <div class="modal-header pt-4">
        <h3 style="color:#000;">AI Medical Report</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body mt-0">
        <h4>Heading 2</h4>
<ul>
    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. </li>
    <li>Suspendisse sed turpis tortor. In tempus dui a velit elementum</li>
    <li>Suspendisse non nisi non nibh finibus imperdiet eget quis sem.</li>
    <li>Cras non gravida justo. Mauris tincidunt est diam, a blandit purus porta ac. </li>
    <li>In quis turpis interdum lectus consectetur faucibus.</li>
</ul>

    <h4>Heading 1</h4>
       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In quis turpis interdum lectus consectetur faucibus. Mauris non quam vitae nulla vulputate interdum. Nunc sodales porttitor pharetra. Curabitur sed orci urna. Phasellus a mattis diam, a luctus augue. Nulla eu fringilla eros. Nulla nec rutrum diam. Morbi sem purus, blandit in efficitur et, porttitor id est. Integer id tellus rhoncus, malesuada lorem ut, accumsan felis.
       </p>
    <p>
Suspendisse sed turpis tortor. In tempus dui a velit elementum, nec ultrices sem aliquet. Nunc nisl dolor, fringilla ut egestas at, accumsan sed ante. Curabitur fringilla magna ligula, vitae malesuada ligula rhoncus id. Etiam varius, sem id vestibulum vulputate, nunc massa molestie arcu, et pellentesque eros tellus vel nulla. Phasellus dignissim enim in scelerisque vestibulum. Fusce libero lectus, bibendum vitae cursus vitae, consequat eget tortor. Duis mattis odio non dui egestas, nec scelerisque sapien dictum.
    </p>
    <p>
Fusce vulputate luctus mi, sed laoreet risus facilisis id. Suspendisse potenti. Quisque ornare lorem vitae neque lacinia, ut euismod dolor posuere. Ut tempor velit felis, sit amet tempus elit porta et. Quisque vel odio sed elit aliquam rutrum. Maecenas eu lacinia neque, eu pharetra purus. Sed consequat tortor nec ligula imperdiet, a faucibus mauris tempus. In semper ut eros ac pretium.
</p>
      </div>
      <div class="modal-footer pt-0">
        <button class="primary-btn pull-right ripple">Save & Continue</button>
     </div>
    
    </div>
  </div>
</div>

    </div>





    
</template>

<script>
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import s3api from "@/api/s3api";
import myWorker from '@/config';
import ImageUploadAPI from "@/api/ImageUpload";

const GenericCache = require("@/common/cache.js").default;
const genCache = new GenericCache("gnmt");

const adddiagnosticcenterurl = "/diagnosticcentre/createdc";
const getalldiagnosticcenterurl = "/diagnosticcentre/getalldc";
const adddiagnosticcentersuburl = "/diagnosticcentre";

export default {
  components:{Messages},
  props: [
    "filesToUpload",
    "encounterid",
    "appointment_id",
    "patientid", 
    "diagnosticcentername",
    "showmodal",
    "updatemodal",
    "parentObj",    
    "selectedTestType",
    "uploadednotes",
    "reportweburl",
    "reportweburlpass",
    "reportweburluname",
    "tenantid",
    "webreportid",
    "filescanbeuploaded",
    "webreportcanbeuploaded",
    "maxreportfilecount",
    "maxwebreportcount"
  ],
  data() {
    return {
      show_modal: false,
      parentproperty: this.parentObj,
      encounter_id: "",
      SelectedSection: "Lab/Scan Reports",
      showWebReportModal: false,
      files: [],
      oldFile: [],
      accept: "image/png,image/gif,image/jpeg,image/webp,application/pdf",
      // extensions: 'gif,jpg,jpeg,png,webp,pdf',
      extensions: ["gif", "jpg", "jpeg", "png", "webp", "pdf"],
      //extensions: /\.(gif|jpe?g|png|webp|pdf)$/i,
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: "fileUploader",
      postAction: "/upload/post",
      putAction: "/upload/put",
      headers: {
        "X-Csrf-Token": "xxxx"
      },
      data: {
        _csrf_token: "xxxxxx"
      },
      autoCompress: 1024 * 1024,
      uploadAuto: false,
      isOption: false,
      addData: {
        show: false,
        name: "",
        type: "",
        content: ""
      },
      editFile: {
        show: false,
        name: ""
      },
      //Pop Up
      PopupVisible: false,
      PopupVisible_prop: false,

      //Keep reports in user albums
      folderName: "",
      modifiedById: "",
      modifiedByName: "",
      tenantId: "",
      encounterId: " ",
      imgfilename: "",
      visit_encounterDate:null,
      encounterNumber:null,
      //ReportType
      reportType: "",
      testType: "",
      //Report Type
      report_types: [
        {
          report_type: "Lab test",
          value: "labReport",
          selected: true
        },
        {
          report_type: "Scan test",
          value: "scanReport",
          selected: false
        },
        {
          report_type: "Others",
          value: "otherReport",
          selected: false
        }
      ],
      selected_report_type: {},
      //Test Types
      lab_test_types: [
        {
          test_name: "Allergy tests",
          selected: false
        },
        {
          test_name: "Blood tests",
          selected: false
        },
        {
          test_name: "Bone Density",
          selected: false
        },
        {
          test_name: "Urine test",
          selected: false
        }
      ],
      scan_test_types: [
        {
          test_name: "CT scan",
          selected: false
        },
        {
          test_name: "ECG",
          selected: false
        },
        {
          test_name: "Ultrasound",
          selected: false
        },
        {
          test_name: "X Ray",
          selected: true
        }
      ],
      other_test_types: [
        {
          test_name: "Prescription",
          selected: false
        },
        {
          test_name: "None",
          selected: false
        }
      ],
      selected_test_type: {},
      selected_reportSubmitMethod: "",
      report_notes: "",
      reportWebsiteUrl: "",
      reportWebsiteUname: "",
      reportWebsitePass: "",
      CustomerTestReportsModel: {},
      CustomerViewModel: [],

      //AWS
      bucketName: "",
      bucket: "",
      foldername: "",
      uploadFlag: true,
      deleteFlag: false,

      //Download Url
      fileUrl: [],
      uploadedFileNames: [],
      //processedFileNames: [],
      report_type: "Lab Test",
      stringToBeCropped: "",
      alreadyUploaded: false,

      //Field Validation
      validated: false,
      fileCount: 0,
      validateReportType: true,
      validateTestType: true,
      //View/Download file
      viewItem: false,
      downLoadItem: false,
      //Update Window is same as Edit Window
      updateModal: false,
      saveContinueBtnTxt: "Save & continue",
      saveCloseBtnTxt: "Save & close",
      editWindowText: "Edit report",
      uploadWindowText: "Upload report",
      editObject: {},
      disabledLabTestSelection: true,
      disabledLabScanSelection: true,

      disabledWebUrl: true,
      disabledWebUserName: true,
      disabledWebPass: true,
      validWebUrl: [true],
      validWebUserName: true,
      validWebUserPass: true,
      validFileExt: true,
      validFileSize: true,
      validFileCount:true,
      validWebReportCount:true,
      //Min username length
      minWebReportUsernameLength: 3,
      minWebReportPassLength: 1,
      alertMessage: null,
      popSaveUpwindowFlag: false,
      alertpopupaction: "",
      recordToDelete: {},
      updateType: "",
      saveType: "",
      updateFlag: false,
      saveFlag: false,
      fileNamesToBeUploadedArr: [],
      fileNamesSuccessfullyUploadedArr: [],
      uploadedFilesNameList: [],
      selectedFiles:[],
      diagnostic_center_name: "",
      role_unique_id: "",
      uploaded_notes: "",
      uploaded_webUrl: "",
      uploaded_webUrlUname: "",
      uploaded_webUrlPass: "",
      authenticationToken: "",
      show_add_diatgnosticCenter: false,
      finalDiagnosticList: [],
      selectedDiagCenter: "",
      selectedDiagCenterTemp: "",
      showNote:false,
      showAddDiagBtn:[false],
      shouldGoToShowClosePopUp:true,
      isdisplaymsg:false,
      sucessmsgtext:"",
      editObjLoaded:false,
      toBeUploadObjLoaded:false,
      showloader:false,
      tempFileList:[],
      datatransferobj:new DataTransfer(),
      webReportDetailsArr:[{
        reportWebsiteUrl:"",
        reportWebsiteUname:"",
        reportWebsitePass:"",
        validWebsiteUrl:true,
        selectedDiagCenter:"",
        diagnostic_center_name:"",
        showAddDiagBtn:false,
        show_add_diatgnosticCenter:false,
        duplicateEntry:false,
        webReportId:""
      }],
      iserrormsg:false,
      browseBtnTxt: "Select files",
      filecountcanbeuploaded:0,
      webreportcountcanbeuploaded:0,
      totalcharallowedfornote:250,
      totaltypedchar:0,
      duplicateUrlArrIndexes:[]
    };
  },
  created() {
    if (localStorage.loggedInUserInfo) {
      this.modifiedById = JSON.parse(localStorage.loggedInUserInfo).unique_id;
      this.modifiedByName = JSON.parse(localStorage.loggedInUserInfo).first_name;
      if(JSON.parse(localStorage.loggedInUserInfo).last_name){
          this.modifiedByName += " "+JSON.parse(localStorage.loggedInUserInfo).last_name;
      }
      this.tenantId = localStorage.tenantid;
      this.role_unique_id = JSON.parse(localStorage.loggedInUserInfo).role
        ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          ? JSON.parse(localStorage.loggedInUserInfo).role.unique_id
          : ""
        : "";
      this.encounterId = " "; //this.guid();
      if (this.modifiedById) {
        //this.ac_get_patientTestReports(this.modifiedById);
      }
      if (localStorage.accesstoken) {
        this.authenticationToken = localStorage.accesstoken;
      }
      this.PopupVisible_prop = true;
      this.PopupVisible = true;
    }
    this.getDiagnosticCenterList();
  },
  mounted() {
    /**
     * JQUERY
     */

    $('[data-toggle="tooltip"]').tooltip({trigger: "hover"});
    // $("#app").css({ height: $(window).height() - 100 + "px" });
    // $("#app").height($(document).height());

    $("#searchbar .search-label").on("click", function(e) {
      e.preventDefault();
      $("#searchbar").toggleClass("collapsed");
    });

    $(window).on("load", function() {
      $(".sector-select")
        .change(function() {
          if ($(this).val() != "default value") {
            $(this).addClass("select_validate");
          } else {
            $(this).removeClass("select_validate");
          }
        })
        .trigger("change");
    });

    $(".save-category").click(function() {
      $(".add-category-part").slideUp();
      $(".add-category-btn").removeClass("open");
    });
  },
  methods: {
    ...mapActions([
      //"ac_uploadToS3bucket",
      "ac_getFromS3Bucket",
      "ac_patient_web_reports_save",
      "ac_get_patientTestReports",
      "ac_update_patientTestReports",
      "ac_delete_patientTestReports",
      "ac_update_reset_patientTestReports"
    ]),

    getFolderName() {
     
      this.foldername = this.$store.state.helper.patient_s3upload_Folders.reportimageFolder;
      
    },
    //Reset File
    resetFile() {
       document.getElementById("uploadFile1").value = "";
       this.fileNamesToBeUploadedArr = [];
       this.fileNamesSuccessfullyUploadedArr = [];
      //Empty selected fileList Obj
      // this.files=[];
      // this.datatransferobj=new DataTransfer();
    },
    //Validate File

    validateFile() {
      var input = document.getElementById("uploadFile1");
      var newFiles = Array.from(input.files);
      var self = this;

      // Initialize the file list once.
      if (!self.datatransferobj) {
        self.datatransferobj = new DataTransfer();
      }

      // Keep track of existing files to prevent duplicates.
      var existingFiles = Array.from(self.datatransferobj.files);

      newFiles.forEach(function (file) {
        var alreadyExists = existingFiles.some(function (existingFile) {
          return (
            existingFile.name === file.name &&
            existingFile.size === file.size &&
            existingFile.lastModified === file.lastModified
          );
        });

        if (!alreadyExists) {
          self.datatransferobj.items.add(file);
          existingFiles.push(file);
        }
      });

      // Use the accumulated, deduplicated file list.
      self.files = self.datatransferobj.files;
      self.fileCount = self.files.length;

      self.selectedFiles = [];
      self.validFileExt = true;
      self.validFileSize = true;
      self.validFileCount =
        self.fileCount > 0 &&
        self.fileCount <= self.filescanbeuploaded;

      var acceptedTypes =
        self.$store.state.helper.acceptedFileTypes || [];

      for (var i = 0; i < self.files.length; i++) {
        var file = self.files[i];
        var ext = file.name.split(".").pop().toLowerCase();

        if (file.size > self.gett_allowedFileSize) {
          self.validFileSize = false;
        }

        if (acceptedTypes.indexOf(ext) === -1) {
          self.validFileExt = false;
        }

        self.selectedFiles.push({
          name: file.name,
          id: self.guid1()
        });
      }

      self.filecountcanbeuploaded = Math.max(
        0,
        self.filescanbeuploaded - self.fileCount
      );

      self.browseBtnTxt =
        self.fileCount > 0 ? "Add files" : "Select files";

      console.log("Validated files:", self.files);
      console.log("Total file count:", self.fileCount);
    },

    //Upload File
    uploadFile(mode) {
      if (this.validFileExt && this.validFileSize && this.validFileCount) {
        this.getFolderName();
        //this.processedFileNames = [];
        if (
          this.tenantId &&
          this.modifiedById &&
          this.modifiedByName
        ) {
          //this.files = document.getElementById("uploadFile1").files;
          console.log("In Upload File ()>>>",this.files);
          this.fileCount = this.files.length;
          ////console.log(this.files);
          if (this.validFileCount) {
            var self = this;
            self.fileUrl = "";
            var corruptedfilearr=[];
            //alert(self.files.length);
            for (var i = 0; i < self.files.length; i++) {
              let file = self.files[i];
              self.fileNamesToBeUploadedArr.push(file.name);
              file.uploadedDatetime = new Date(
                new Date().toUTCString()
              ).getTime();
              file.uploadedById = self.modifiedById;
              file.uploadedByName = self.modifiedByName;
              file.tenantId = self.tenantId;
              file.encounterId = self.encounterId; //Encounter ID
              //console.log("file>>>>>>>>>>>>>>" + i, file);
              let data1;
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function() {
                //console.log("reader.result>>>>>>>>>>>>>>"+i,reader.result);
                if (reader.result && reader.readyState) {
                  data1 = atob(reader.result.split(",")[1]);
                }
                if (data1) {
                  let arr = new Uint8Array(data1.length);
                  for (let i = 0; i < data1.length; i++) {
                    arr[i] = data1.charCodeAt(i);
                  }
                  let filetoUpload = new File([arr], file.name, {
                    type: file.type
                  });
                  // This is the folder structure on S3: Base_Folder_Name/tenantId/PatientId/FileName.ext
                  let fileInfo = {
                    file: filetoUpload,
                    filename:
                      self.stringToBeCropped +
                      file.name.replace("_", "").replace(/\s/g, ""),
                    folderName: self.foldername
                  };
                  //console.log("fileInfo " + i, fileInfo);
                  //Upload the file to S3
                  self.uploadedFilesNameList=[];
                  s3api.uploadToS3Bucket(self.tenantId, fileInfo)
                    .then(respo => {
                      if (respo && respo.data && respo.data.message) {
                        if(respo.data.message!=='File upload failed. File not good!'){
                          let fname = "";
                          //let extnsn = respo.data.message.substring(respo.data.message.lastIndexOf('.')+1, respo.data.message.length);
                          if(respo.data.message.length){
                            if(respo.data.message.split('_')[6]){
                              fname = respo.data.message.substring(respo.data.message.indexOf(respo.data.message.split('_')[6]),respo.data.message.length);
                            }
                            else{
                              fname = respo.data.message;
                            }
                          }
                          let tempobj = {
                            report_actual_name : file.name,
                            report_user_friendly_name: file.name,
                            report_file_key: respo.data.message,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            record_status:true
                            //diagnostic_center_name: self.diagnostic_center_name,
                            //created_username: self.modifiedByName
                          };
                          self.uploadedFilesNameList.push(tempobj);
                          tempobj={};
                          self.iserrormsg=false;
                        }
                        else{
                          corruptedfilearr.push(file.name);
                          let tempobj = {
                            report_actual_name : file.name,
                            report_user_friendly_name: respo.data.message,
                            report_file_key: respo.data.message,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            diagnostic_center_name: self.diagnostic_center_name,
                            created_username: self.modifiedByName
                          };
                          self.uploadedFilesNameList.push(tempobj);
                          self.iserrormsg=true;
                          self.sucessmsgtext = file.name+" is a corrupted file. Could not be uploaded.";
                          self.isdisplaymsg = true;
                          setTimeout((xy)=>{self.closeMessage();},5000);
                        }
                        
                      }
                    })
                    .finally(zz => {
                      if(self.uploadedFilesNameList.length === self.files.length){
                        self.uploadedFilesNameList = self.uploadedFilesNameList.filter((xx,ind)=>{
                          return xx.report_actual_name !== corruptedfilearr[ind] && xx.report_file_key !=='File upload failed. File not good!';
                        });
                        if(self.uploadedFilesNameList && self.uploadedFilesNameList.length){
                          self.isdisplaymsg = false;
                          var multipleFlag = self.uploadedFilesNameList.length>1?"Files":"File";
                          
                          self.CustomerTestReportsModel = {
                            report_type: self.reportType,
                            test_type: self.testType,
                            uploaded_date: new Date().toISOString(),
                            created_userid: self.modifiedById,
                            invfilelist: self.uploadedFilesNameList,
                            report_notes: self.report_notes? self.report_notes: "",
                           // investigation_id: "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",
                            encounter_id: self.encounterid,
                            unread: true
                          };
                          
                          var encdata = {};
                          var imgData={};
                          if(sessionStorage.getItem("encounterdetails"))
                          {
                            var encounData= JSON.parse(sessionStorage.getItem("encounterdetails"))
                            self.encounterNumber = encounData.patient_encounter_number;
                            self.visit_encounterDate = encounData.created_date;
                          }
                            
                          encdata.created_userid = self.modifiedById;
                          encdata.created_username =self.modifiedByName;                
                          encdata.report_actual_name = file.name;
                          encdata.filelist=self.uploadedFilesNameList;
                          encdata.report_file_key = fileInfo.filename;
                          encdata.report_user_friendly_name = file.name;
                          //encdata.uploaded_date = new Date().toISOString();
                          encdata.patient_encounter_number = self.encounterNumber;
                          encdata.customer_id = self.patientid;             
                          encdata.encounter_id = self.encounterid;
                          encdata.appointment_id=self.appointment_id;
                        
                          encdata.visit_date = self.visit_encounterDate;
                          //imgData.last_uploaded_Img_key =respo.data.message;
                          encdata.last_uploaded_Img_key =fileInfo.filename;
                          // self.encounterData.uploadedImageslist.push(encdata);
                          // self.encounterData.last_uploaded_Img_key = imgData.last_uploaded_Img_key;
                          // self.fileCount+=1;
                          if (typeof encdata.report_file_key === "string" && encdata.report_file_key) {
                            self.foldername =
                              self.tenantId +
                              self.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
                              encdata.report_file_key;
                          }
                          
                          ImageUploadAPI.fileUpload(encdata)
                            .then(categResponse => {
                            //if (categResponse.length>0) {
                              self.$parent.setViewFileListPopUpData(categResponse);
                              self.closePopUp("goBack");
                              //  self.getimageuploadeddata();
                            //}
                          })
                          .catch((err)=>{
                            console.error("Upload Failed! ", err);
                            //self.show_modal = false;
                            self.sucessmsgtext="File upload failed!";
                            self.iserrormsg=true;
                            self.isdisplaymsg = true;                          
                            setTimeout((xy)=>{self.closeMessage();},5000);
                            self.showloader=false;
                          })
                          .finally(zyzy=>{
                            if(corruptedfilearr && corruptedfilearr.length)
                            {
                              let filenames = corruptedfilearr.join();
                              self.sucessmsgtext = filenames +" - Could not be uploaded.";
                              self.iserrormsg=true;
                              self.isdisplaymsg=false;
                              self.isdisplaymsg = true;
                              setTimeout((xy)=>{self.closeMessage();},5000);
                            }
                            if(self.uploadedFilesNameList && self.uploadedFilesNameList.length)
                            {
                              let tempuploadedarr = [];
                              self.uploadedFilesNameList.forEach(y=>{
                                tempuploadedarr.push(y.report_actual_name);
                              });
                              let filenames = tempuploadedarr.join();
                              self.sucessmsgtext="";
                              self.iserrormsg=false;
                              self.isdisplaymsg = true;
                              self.sucessmsgtext = filenames+" uploaded successfully";
                              setTimeout((xy)=>{self.closeMessage();},self.$store.state.helper.msgDisplayTime);
                            }
                          });
                        }
                        else{
                          self.showloader = false;
                        }
                        self.uploadFlag = false;
                        self.showloader = false;
                      }
                    });
                  //};
                  //after upload request save the info into the database
                  self.tempFiles = file.name.replace("_", "").replace(/\s/g, "");
                }
              };
            }
          }
        }
      } else {
        this.$store.state.helper.st_alert_message = "";
        if (!this.validFileExt) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message = "Invalid file type";
        }
        if (!this.validFileSize) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message =
            "Maximum upload size exceeded.</br>File size should be within 5MB";
        }
        if (!this.validFileExt && !this.validFileSize) {
          this.$store.state.helper.showAlertMsgPopUP = true;
          this.$store.state.helper.st_alert_message =
            "Invalid file type.</br>Maximum upload size exceeded.</br>File size should be within 5MB";
        }
      }
    },
    //Save Report Details
    SaveReport(mode,isupdate) {      
      //console.log("In SaveReport()---->");
      var self = this;
      self.validateFile();
      self.reportType = "";
      self.testType = "";
      //self.saveFlag = true;
      //self.showloader=true;
      
      if (this.validFileCount){
        if (this.validFileExt && this.validFileSize && this.validFileCount) {
          self.showloader=true;
          self.uploadFlag = true;
          var newguid = this.guid1();
          self.stringToBeCropped = (
            self.tenantId +
            "_" +
            self.modifiedById +
            "_" +                       
            newguid + "_"
          ).replace(/\s/g, "");
          self.uploadedFilesNameList = [];
          if(!self.tenantid){
            console.error("tenant id is missing",self.tenantId);
          }
          self.uploadFile(mode);
        }
      }
    },
    //Save & Continue
    saveReportAndReset() {
      //First Save the File
      this.SaveReport(true);
      this.saveType = "save-reset";
    },
    //Update & close report
    updateReportData(type) {
      //console.log("In UpdateReport()---->");
      if (type === "update-single") {
        this.updateType = type;
      }
      this.updateFlag = true;
      var self = this;
      self.isdisplaymsg = false;
      self.reportType = "";
      self.testType = "";
      if (self.selected_report_type) {
        if (
          self.selected_report_type.value &&
          self.selected_report_type.selected
        ) {
          self.reportType = self.selected_report_type.value;
        }
      }
      if (self.selected_test_type) {
        if (
          self.selected_test_type.test_name &&
          self.selected_test_type.selected
        ) {
          self.testType = self.selected_test_type.test_name;
        }
      }
      if (self.selected_reportSubmitMethod === "_web") {
        if (
          self.reportWebsiteUrl !== "" &&
          self.reportWebsiteUname !== "" &&
          self.reportWebsitePass !== ""
        ) {
          self.CustomerTestReportsModel = {
            report_type: self.reportType,
            test_type: self.testType,
            diagnostic_center_name: self.diagnostic_center_name,
            report_notes: self.report_notes ? self.report_notes : "",
            uploaded_date: new Date().toISOString(),
            created_userid: self.modifiedById,
            report_webUrl: self.reportWebsiteUrl,
            report_webUrlUname: self.reportWebsiteUname,
            report_webUrlPass: self.reportWebsitePass,
            //investigation_id: "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",
            encounter_id: self.encounterid
          };
          //console.log(self.CustomerTestReportsModel);
          s3api
            .saveInvestigationFileName(
              self.CustomerTestReportsModel,
              self.tenantId,
              self.role_unique_id,
              self.modifiedById
            )
            .then(res => {              
              if (res.data && res.data.result && res.data.result.length) {
                this.updateFlag = false;
                self.closePopUp("goBack");
                self.sucessmsgtext = "Updated successfully";
                self.isdisplaymsg = true;
                setTimeout((xy)=>{self.closeMessage();},self.$store.state.helper.msgDisplayTime);
              }
            })
            .finally((zzx)=>{
              if(self.parentObj){
                if(typeof self.parentObj.getinvestigationbyencounteridanduniqueid === "function"){
                  //self.parentObj.getListFlag = true;
                  self.parentObj.getinvestigationbyencounteridanduniqueid(self.encounterid,"27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27");
                }
              }
            });
        }
      }
    },
    updateReportAndReset(type) {
      if (type === "update-reset") {
        this.updateType = type;
      }
      this.updateReportData(this.updateType);
    },
    resetPopUp() {
      this.reportType = "";
      this.testType = "";
      this.foldername = "";
      this.report_notes = "";
      this.reportWebsiteUrl = "";
      this.reportWebsiteUname = "";
      this.reportWebsitePass = "";
      this.disabledLabTestSelection = true;
      this.disabledScanTestSelection = true;
      this.selected_report_type = {};
      this.CustomerTestReportsModel = {};
      this.selected_test_type = {};
      this.selected_reportSubmitMethod = "";
      this.validateReportType = true;
      this.deleteFlag = false;
      this.uploadFlag = false;
      this.validFileExt = true;
      this.validFileSize = true;
      if (document.getElementById("uploadFile1")) {
        document.getElementById("uploadFile1").value = "";
      }
      this.show_add_diatgnosticCenter = false;
      //this.finalDiagnosticList = [];
      this.selectedDiagCenter = "";
      this.selectedDiagCenterTemp = "";
      this.selectedFiles=[];
      //Empty selected fileList Obj
      this.files=[];
      this.datatransferobj=new DataTransfer();
      //Edit Object One time load Flag
      this.editObjLoaded = false;
      this.toBeUploadObjLoaded = false;
      this.webReportDetailsArr=[{
        reportWebsiteUrl:"",
        reportWebsiteUname:"",
        reportWebsitePass:"",
        validWebsiteUrl:true,
        selectedDiagCenter:"",
        diagnostic_center_name:"",
        showAddDiagBtn:false,
        show_add_diatgnosticCenter:false,
        duplicateEntry:false,
        webReportId:""
      }];
      this.showNote=false;
      this.tempFileList = [];
      //this.$store.state.patient.st_reports = null;
      //this.$store.state.S3Proxy.st_uploadedfile = null;
      //this.$store.state.helper.showAlertMsgPopUP = false;
      // if(this.$refs && this.$refs.alertpopup)
      // {
      //   this.$refs.alertpopup.btnText = "";
      // }
    },
    getBase64(file) {
      ////console.log("Inside getBase64");
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        ////console.log(reader.result);
        return reader.result;
      };
      reader.onerror = function(error) {
        //console.log("Error: ", error);
        return error;
      };
    },
    
    guid1: function() {
      // http://www.ietf.org/rfc/rfc4122.txt
      var s = [];
      var hexDigits = "0123456789abcdef";
      //var intDigits = "0123456789";
      for (var i = 0; i < 5; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      // s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      // s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    
    getObj(file_name) {
      //var s3key= this.tenantId+this.foldername+this.tenantId+"_"+this.modifiedById+"_VS_CODE_keyboard-shortcuts-windows.pdf";
      var s3key =
        this.tenantId +
        this.foldername +
        this.tenantId +
        "_" +
        this.modifiedById +
        "_" +
        file_name;
      this.ac_getFromS3Bucket(s3key);
    },
    formatDate: function(dt) {
      return (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      );
    },
    getReportType: function() {
      ////console.log(this.selected_report_type);
      if (this.selected_report_type) {
        if (this.selected_report_type.report_type === "Lab test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "labReport";
        }
        if (this.selected_report_type.report_type === "Scan test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "scanReport";
        }
        if (this.selected_report_type.report_type === "Others") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "otherReport";
        }
      }
    },
    getTestType: function() {
      if (this.selected_test_type) {
        if (this.selected_report_type.hasOwnProperty("report_type")) {
          this.selected_test_type.selected = true;
        } else {
          this.validateReportType = false;
          return;
        }
      }
    },
    getUpdateReportType: function() {
      if (this.selected_report_type) {
        if (this.selected_report_type.report_type === "Lab test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "labReport";
          this.selected_test_type.test_name = "";
        }
        if (this.selected_report_type.report_type === "Scan test") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "scanReport";
          this.selected_test_type.test_name = "";
        }
        if (this.selected_report_type.report_type === "Others") {
          this.selected_report_type.selected = true;
          this.selected_report_type.value = "otherReport";
          this.selected_test_type.test_name = "";
        }
      }
    },
    closePopUp: function(item) {      
      this.$store.state.helper.showAlertMsgPopUP = false;
      this.$store.state.helper.st_alert_message = "";
      if (item === "fileReport") {
        this.show_modal = false;
        if(this.parentObj.$data.showModal){
          this.parentObj.$data.showModal = false;
        }

        ////console.log("In CLOSE POP UP>>>>>>>>>>>");
        ////console.log(this.$refs);
        // if(this.$refs && this.$refs.alertpopup)
        // {
        //   this.$refs.alertpopup.btnText = "Ok";
        // }
        // this.$store.state.helper.showAlertMsgPopUP = true;
        // //console.log(this.$store.state.helper.showAlertMsgPopUP);
      }
      if (item === "goBack") {
        this.shouldGoToShowClosePopUp = false;
        this.show_modal = false;
        this.updateModal = false;

        //console.log("this.parentObj.$data.showModal>>>",this.parentObj.$data);
        //Following is for dashboard.vue data
        if(this.parentObj.$data.showModal){
          this.parentObj.$data.showModal = false;
        }
        if(this.parentObj.$data.showUpdateModal){
          this.parentObj.$data.showUpdateModal = false;
        }
      }
      if (item === "webReport") {
        this.showWebReportModal = false;
      }
      if (item === "editReport") {
        this.updateModal = false;
        this.show_modal = false;
      }
      //If Save & continue don't close the popup, instead reset it.
      // if(this.saveType === 'save-reset')
      // {
      //   this.resetPopUp();
      //   this.printValue();
      // }
    },
    viewFile: function(item, itemtype, report_Type) {
      if (typeof item === "string" && itemtype === "uploadedfile") {
        if (report_Type === "labReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .latReportDownloadPath +
            item;
        }
        if (report_Type === "scanReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .scanReportDownloadPath +
            item;
        }
        if (report_Type === "otherReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .UploadedImagePath +
            item;
        }
        //alert(this.foldername);
        this.ac_getFromS3Bucket(this.foldername);
        this.viewItem = true;
        this.downLoadItem = false;
      } else if (typeof item === "object" && itemtype === "webReport") {
        //alert(item.report_webUrl+"->"+item.report_webUrlUname+"->"+item.report_webUrlPass);
        this.reportWebsiteUrl = item.report_webUrl;
        this.reportWebsiteUname = item.report_webUrlUname;
        this.reportWebsitePass = item.report_webUrlPass;
        this.showWebReportModal = true;
      }
    },
    downloadFile: function(item, itemtype, report_Type) {
      if (
        typeof item === "string" &&
        itemtype === "uploadedfile" &&
        item.length > 0
      ) {
        if (report_Type === "labReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .latReportDownloadPath +
            item;
        }
        if (report_Type === "scanReport") {
          this.foldername =
            this.tenantId +
            this.$store.state.helper.tenant_s3upload_Folders
              .scanReportDownloadPath +
            item;
        }
        this.ac_getFromS3Bucket(this.foldername);
        this.viewItem = false;
        this.downLoadItem = true;
      }
    },
    onClickChild: function(value) {
      this.PopupVisible_prop = value;
    },
    visitSite: function() {
      var win = window.open(this.reportWebsiteUrl, "_blank");
      if (win) {
        //Browser has allowed it to be opened
        win.focus();
      } else {
        //Browser has blocked it
        //alert("Please allow popups for this website");
        self.sucessmsgtext = "Please allow popups for this website";
        self.isdisplaymsg = true;
      }
    },
    updateItem: function(item) {
      //console.log(item);
      //this.resetPopUp();
      this.editObject = item;
      this.updateModal = true;
      this.selected_reportSubmitMethod = "_web";
      this.editWindowText = "Edit report";
      this.uploadWindowText = "Upload report";
      this.show_modal = false;
      this.saveContinueBtnTxt = "Update";
      this.selected_report_type = {};
      this.selected_test_type = {};
      var arr = [];
      if (item) {
        if (
          item.report_webUrl &&
          item.report_webUrlUname &&
          item.report_webUrlPass
        ) {
          if (item.report_type) {
            if (item.report_type === "labReport") {
              this.selected_report_type = {
                report_type: "Lab test",
                value: item.report_type,
                selected: true
              };
            } else if (item.report_type === "scanReport") {
              this.selected_report_type = {
                report_type: "Scan test",
                value: item.report_type,
                selected: true
              };
            } else if (item.report_type === "otherReport") {
              this.selected_report_type = {
                report_type: "Others",
                value: item.report_type,
                selected: true
              };
            }
          }
          if (item.report_type === "labReport") {
            arr = this.lab_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          if (item.report_type === "scanReport") {
            arr = this.scan_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          if (item.report_type === "otherReport") {
            arr = this.other_test_types;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].test_name == item.test_type) {
                this.selected_test_type.test_name = item.test_type;
                this.selected_test_type.selected = true;
                break;
              }
            }
          }
          this.report_notes = item.report_notes ? item.report_notes : "";

          if (
            item.report_webUrl &&
            item.report_webUrl.length > 0 &&
            item.report_webUrlUname &&
            item.report_webUrlPass
          ) {
            this.selected_reportSubmitMethod = "_web";
            this.reportWebsiteUrl = item.report_webUrl;
            this.reportWebsiteUname = item.report_webUrlUname;
            this.reportWebsitePass = item.report_webUrlPass;
            //this.selectedUniqueId = item.unique_id;
          }
          if (self.selected_reportSubmitMethod === "_web") {
            if (
              self.reportWebsiteUrl !== "" &&
              self.reportWebsiteUname !== "" &&
              self.reportWebsitePass !== ""
            ) {
              self.validated = true;
              /*self.CustomerTestReportsModel={
                      customer_Id: self.modifiedById,
                      tenant_id: self.tenantId,
                      encounter_Id: " ", //this needs to be a space or any string value
                      report_type: self.reportType,
                      test_type: self.testType,
                      created_date: new Date().toISOString(),
                      created_userid: self.modifiedById,
                      record_status: true,
                      report_notes: self.report_notes? self.report_notes : "",
                      report_webUrl: self.reportWebsiteUrl,
                      report_webUrlUname: self.reportWebsiteUname,
                      report_webUrlPass: self.reportWebsitePass,
                  };*/
            }
            setTimeout(() => {
              ////console.log(self.CustomerTestReportsModel);
              //s3api.ac_patient_web_reports_save(self.CustomerTestReportsModel);
            }, 0);
            //to update the list
            this.CustomerViewModel.unshift(this.CustomerTestReportsModel);
          }
        }
      }
    },
    changeSource: function(item) {
      if (this.updateModal) {
        this.show_modal = false;
        if (this.selected_reportSubmitMethod === item) {
          var respo = confirm("Do you want to change the resource type?");
          if (respo == true) {
            this.show_modal = false;
            this.selected_reportSubmitMethod = "_desktop";
          } else {
            this.show_modal = false;
            this.selected_reportSubmitMethod = "_web";
          }
        }
      }
    },
    deleteReport: function(item) {
      if (item) {
        if (item.customer_Id === this.modifiedById) {
          this.deleteFlag = true;
          this.recordToDelete = item;
          this.$store.state.helper.showAlertMsgPopUP = false;
          this.$store.state.helper.st_alert_message = "";
          this.alertpopupaction = "delete-report";
          this.$store.state.helper.showDelConfirmPopUp = true;
          //this.ac_delete_patientTestReports(item);
        }
      }
    },
    confirmDelete() {
      if (this.alertpopupaction === "delete-report") {
        this.ac_delete_patientTestReports(this.recordToDelete);
      }
    },
    toDashboard: function() {
      this.$router.push("/dashboard");
    },
    isValidURL: function(str) {
      var regexp = /^(?:(?:https?|ftp):\/\/)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (regexp.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    printValue() {
      // //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      // //console.log("1",this.reportType);
      // //console.log("2",this.testType);
      // //console.log("3",this.foldername);
      // //console.log("4",this.report_notes);
      // //console.log("5",this.reportWebsiteUrl);
      // //console.log("6",this.reportWebsiteUname);
      // //console.log("7",this.reportWebsitePass);
      // //console.log("8",this.disabledLabTestSelection);
      // //console.log("10",this.disabledScanTestSelection);
      // //console.log("11",this.selected_report_type);
      // //console.log("12",this.CustomerTestReportsModel);
      // //console.log("13",this.selected_test_type);
      // //console.log("14",this.selected_reportSubmitMethod);
      // //console.log("15",this.validateReportType);
      // //console.log("16",this.deleteFlag);
      // //console.log("17",this.uploadFlag);
    },
    show_add_diatgnosticCenter_part() {
      this.show_add_diatgnosticCenter = this.show_add_diatgnosticCenter? false: true;
    },
    addDiagnostic(diagData) {
      //console.log(rest_service.baseURL + adddiagnosticcenterurl);
      var self = this;
      var diagObj = {
        name: diagData,
        created_by_enitity_type: this.role_unique_id,
        created_by: this.modifiedById,
        created_date: new Date().toISOString()
      };
      //console.log("diagData>>>>", diagData);
      self.showloader=true;
      Axios.request(rest_service.baseURL + adddiagnosticcenterurl, {
        method: "post",
        headers: {
          x_tenant_id: this.tenantId,
          role_unique_id: this.role_unique_id,
          route_entity_name: adddiagnosticcentersuburl,
          loggedin_user_unique_id: this.modifiedById,
          Authorization: this.authenticationToken
        },
        data: diagObj
      })
      .then(xy => {
        if (xy && xy.data && xy.data.result && xy.data.result) {
          //console.log("AFTER DIAGNOSTIC DATA ADDITION>>>>>>", xy);
          self.finalDiagnosticList = xy.data.result;
          xy.data.result.forEach(z => {
            if (z.name === diagData) {
              self.selectedDiagCenter = z.unique_id;
            }
          });
          self.selectedDiagCenterTemp = "";
          self.show_add_diatgnosticCenter = false;
          self.showloader=false;
        }
      })
      .catch(function(err) {
        console.error(err);
        self.showloader=false;
      });
    },
    getDiagnosticCenterList() {
      var self = this;
      var diagnosticurl = rest_service.baseURL + getalldiagnosticcenterurl;
      var diagnosticHeaders= {
        tenantid: this.tenantId,
        role_unique_id: this.role_unique_id,
        loggedin_user_unique_id: this.modifiedById,
        entity_name: adddiagnosticcentersuburl,
        accesstoken: this.authenticationToken,
        url: diagnosticurl
      };
      if (!localStorage.getItem("diagnosticcenterlist")) {
        var disgnosticmsg=JSON.stringify(diagnosticHeaders);
        myWorker.send(disgnosticmsg)
        .then(xy => {
          if (xy && xy.result) {
            //console.log("ALL DIAGNOSTIC CENTER NAME>>>>>>", xy);
            self.finalDiagnosticList = xy.result;
            localStorage.setItem("diagnosticcenterlist",JSON.stringify(self.finalDiagnosticList));
          }
        })
        .catch(function(err) {
          console.error(err);
        });
      }
      else{
        self.finalDiagnosticList = JSON.parse(localStorage.getItem("diagnosticcenterlist"));
      }
    },
    getSelectedDiagnosticCenter(item) {
      if (item) {
        //diagnostic_center_name
        this.finalDiagnosticList.forEach(x => {
          if (item === "OTHERS"){
            this.showAddDiagBtn[index] = true;
          }
          else if (x.unique_id === item) {
            this.showAddDiagBtn= false;
            this.diagnostic_center_name = x.name;
          }
      });
      if(self.selected_reportSubmitMethod==='web'){

		  }
      }
    },
    getIndexedSelectedDiagnosticCenter(item,index) {
      if (item && item.selectedDiagCenter) {
        //diagnostic_center_name
        this.finalDiagnosticList.forEach(x => {
          if (item.selectedDiagCenter === "OTHERS"){
            item.showAddDiagBtn = true;
          }
          else if (x.unique_id === item.selectedDiagCenter) {
            item.showAddDiagBtn = false;
            item.diagnostic_center_name = x.name;
          }
        });
      }
    },
    show_add_indexed_diatgnosticCenter_part(item,index) {
      item.show_add_diatgnosticCenter = item.show_add_diatgnosticCenter? false: true;
    },
    addIndexedDiagnostic(item,diagData) {
      //console.log(rest_service.baseURL + adddiagnosticcenterurl);
      var self = this;
      var diagObj = {
        name: diagData,
        created_by_enitity_type: this.role_unique_id,
        created_by: this.modifiedById,
        created_date: new Date().toISOString()
      };
      //console.log("diagData>>>>", diagData);

        Axios.request(rest_service.baseURL + adddiagnosticcenterurl, {
          method: "post",
          headers: {
            x_tenant_id: this.tenantId,
            role_unique_id: this.role_unique_id,
            route_entity_name: adddiagnosticcentersuburl,
            loggedin_user_unique_id: this.modifiedById,
            Authorization: this.authenticationToken
          },
          data: diagObj
        })
        .then(xy => {
          if (xy && xy.data && xy.data.result && xy.data.result) {
            //console.log("AFTER DIAGNOSTIC DATA ADDITION>>>>>>", xy);
            self.finalDiagnosticList = xy.data.result;
            xy.data.result.forEach(z => {
              if (z.name === diagData) {
                item.selectedDiagCenter = z.unique_id;
              }
            });
            self.selectedDiagCenterTemp = "";
            item.show_add_diatgnosticCenter = false;
          }
        })
        .catch(function(err) {
          console.error(err);
        });
    },
    showHideNote(){
      this.showNote = !this.showNote;
      $(".add-categoryst").slideToggle();
      $("#add_category i.material-icons").toggleClass("open");
    },
    countdown(){
			 this.remainingCount = this.maxCount - this.notes.length;
    },
    removeFile(items){
      var dt = new DataTransfer();
      var tempFiles = this.files;
      var self = this;
      Array.from(tempFiles).forEach( function(s, index){
          if(s.guid !== items.id){
            //console.log(self.files[index]);
            dt.items.add(self.files[index]);
          }
      });
      self.datatransferobj = new DataTransfer();
      self.datatransferobj = dt;
      self.files = self.datatransferobj.files;
      self.fileCount = self.files.length;
      if(this.fileCount>0){
        this.browseBtnTxt = "Add files";
      }
      else{
        this.browseBtnTxt = "Select files";
      }
      self.selectedFiles=self.selectedFiles.filter((xy)=>{
        return xy.id !== items.id;
      });
      // if((self.fileCount < self.filescanbeuploaded) && (self.filecountcanbeuploaded < self.filescanbeuploaded)){
      //   self.filecountcanbeuploaded += 1;
      // }
      // else{
      //   if(self.fileCount < self.filecountcanbeuploaded){
      //     self.filecountcanbeuploaded = self.filecountcanbeuploaded - self.fileCount;
      //   }
      //   else{
      //     self.filecountcanbeuploaded = 0;
      //   }
      // }
      self.filecountcanbeuploaded = self.filescanbeuploaded - self.fileCount >= 0? (self.filescanbeuploaded - self.fileCount) : 0;

      self.validFileCount = (self.fileCount + self.filecountcanbeuploaded) <= self.filescanbeuploaded ?true:false;
      console.log("After File Removed>>>",self.files,self.selectedFiles);
    },
    closeMessage(){
      this.isdisplaymsg=false;
      this.iserrormsg = false;
    },
    //To generate random GUID (guid ans s4)
    guid() {
        return "ss-s-s-s-sss".replace(/s/g, this.s4);
    },
    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },
    addfields(){
      //webReportDetailsArr
      console.log("WEBREPORT DETAILS>>>>",this.webReportDetailsArr);
      if(this.show_modal){
        var temp={
          reportWebsiteUrl:"",
          reportWebsiteUname:"",
          reportWebsitePass:"",
          validWebsiteUrl:true,
          selectedDiagCenter:"",
          diagnostic_center_name:"",
          showAddDiagBtn:false,
          show_add_diatgnosticCenter:false,
          duplicateEntry:false,
          webReportId:""
        };
        //Validate the next entry
        if(this.isValidURL(this.webReportDetailsArr[this.webReportDetailsArr.length -1].reportWebsiteUrl) && !this.webReportDetailsArr[this.webReportDetailsArr.length -1].duplicateEntry){
          this.webreportcountcanbeuploaded = (this.webreportcanbeuploaded - (this.webReportDetailsArr.length+1)) >= 0? (this.webreportcanbeuploaded - (this.webReportDetailsArr.length+1)) : 0;
          // if(this.webReportDetailsArr.length===(this.webreportcanbeuploaded-1)){
          //   this.webreportcountcanbeuploaded = this.webreportcountcanbeuploaded == 0? 1:0;
          // }
          if(this.webreportcountcanbeuploaded>=0){
            this.webReportDetailsArr.push(temp);
          }
        }
      }
      if(this.updateModal){
        var temp={
          reportWebsiteUrl:"",
          reportWebsiteUname:"",
          reportWebsitePass:"",
          validWebsiteUrl:true,
          selectedDiagCenter:"",
          diagnostic_center_name:"",
          showAddDiagBtn:false,
          show_add_diatgnosticCenter:false,
          duplicateEntry:false
        };
        this.webReportDetailsArr.push(temp);
      }
      //this.validWebUrl.push(true);
      console.log("After Adding Field>>>",this.webReportDetailsArr);
    },
    removefields(i){
      this.webreportcountcanbeuploaded = (this.webreportcanbeuploaded - (this.webReportDetailsArr.length-1)) >= 0? (this.webreportcanbeuploaded - (this.webReportDetailsArr.length-1)) : 0;
      if(this.webreportcountcanbeuploaded>=0){
        this.webReportDetailsArr.splice(i,1);
      }
      var duplicatecount=0;
      this.webReportDetailsArr.forEach((y)=>{
        if(y.duplicateEntry == true){
          duplicatecount+=1;
        }
      });
      if(duplicatecount==1){
        this.webReportDetailsArr.forEach((y)=>{
          if(y.duplicateEntry == true){
            y.duplicateEntry=false;
          }
        });
      }
    },
    validateField(weburlObj,index){
      if (weburlObj) {
        if (weburlObj.reportWebsiteUrl && weburlObj.reportWebsiteUrl.length >0){
          weburlObj.validWebsiteUrl = this.isValidURL(weburlObj.reportWebsiteUrl);
        }
        if(weburlObj.validWebsiteUrl){
          for(var i=0;i<this.webReportDetailsArr.length;i++){
            if(i!=index){
              if(this.webReportDetailsArr[i].reportWebsiteUrl == weburlObj.reportWebsiteUrl){
                weburlObj.duplicateEntry = true;
                this.webReportDetailsArr[i].duplicateEntry = true;
                this.duplicateUrlArrIndexes.push(i);
                break;
              }
              else{
                weburlObj.duplicateEntry = false;
                this.webReportDetailsArr[i].duplicateEntry = false;
              }
            }
            else{
              weburlObj.duplicateEntry = false;
              this.webReportDetailsArr[i].duplicateEntry = false;             
            }
          }
        }
      }
    },
    countChar($event){
      this.totaltypedchar = this.report_notes.length;
      if(this.totaltypedchar<=this.totalcharallowedfornote){
        console.log(this.report_notes, this.totaltypedchar);
      }
      else{
        this.report_notes = this.report_notes.substring(0,this.totalcharallowedfornote);
        this.totaltypedchar = this.report_notes.length;
      }
    },
    resetOtherFields(){
      if(this.selected_reportSubmitMethod==='_desktop'){
        this.webReportDetailsArr=[{
          reportWebsiteUrl:"",
          reportWebsiteUname:"",
          reportWebsitePass:"",
          validWebsiteUrl:true,
          selectedDiagCenter:"",
          diagnostic_center_name:"",
          showAddDiagBtn:false,
          show_add_diatgnosticCenter:false,
          duplicateEntry:false,
          webReportId:""
        }];
        this.webreportcountcanbeuploaded = parseInt(this.webreportcanbeuploaded,10)-this.webReportDetailsArr.length;
        this.report_notes="";
      }
      else{
        if(document.getElementById("uploadFile1")){
          document.getElementById("uploadFile1").value="";
        }
        this.datatransferobj=new DataTransfer();
        this.selectedFiles=[];
        this.files=[];
        this.tempFileList=[];
        this.validFileExt= true;
        this.validFileSize= true;
        this.validFileCount=true;
        this.filecountcanbeuploaded = parseInt(this.filescanbeuploaded,10);
        this.report_notes="";
      }
    }
  },
  computed: { 
    ...mapGetters([
      "gett_allstatus",
      "gett_downloadfileUrl",
      "gett_uploadedfile",
      "gett_report_url",
      "gett_patient_reports",
      "gett_deletedPatient_reports",
      "gett_updatedPatient_reports",
      "gett_allowedFileSize"
    ]),
    showClosePopUp() {
      var self = this;
      self.show_modal = self.showmodal;
      self.browseBtnTxt = "Select files";
      if (!self.show_modal)
      {
        self.toBeUploadObjLoaded = false;
        document.body.classList.remove("modal-open");
        self.getDiagnosticCenterList();
        self.resetPopUp();
      }
      else
      {
        document.body.classList.add("modal-open");
      }
    },
    showCloseEditPopUp() {
	    var self = this;
      self.updateModal = self.updatemodal;
      if(self.updateModal && !self.editObjLoaded){
      self.selectedDiagCenter = self.diagnosticcentername;
      self.selected_reportSubmitMethod = "_web";	
      self.report_notes = self.uploadednotes;
      self.reportWebsiteUrl = self.reportweburl;
      self.reportWebsiteUname = self.reportweburluname;
      self.reportWebsitePass = self.reportweburlpass;
      self.tenantId = self.tenantid;

      
      
      self.webReportDetailsArr=[];
      var temp={
        reportWebsiteUrl:self.reportWebsiteUrl,
        reportWebsiteUname:self.reportWebsiteUname,
        reportWebsitePass:self.reportWebsitePass,
        selectedDiagCenter:self.selectedDiagCenter,
        diagnostic_center_name: "",
        validWebsiteUrl:true,
        showAddDiagBtn:false,
        show_add_diatgnosticCenter:false,
        duplicateEntry:false,
        webReportId:self.webreportid
      };
      self.finalDiagnosticList.forEach(x => {
        if (x.unique_id === self.selectedDiagCenter) {
          temp.diagnostic_center_name = x.name;
        }
      })
      self.webReportDetailsArr.push(temp);
        console.log("TESTREPOTPOPUP>>>>showCloseEditPopUp()>>>>",self.selected_reportSubmitMethod, self.report_notes, self.reportWebsiteUrl, self.reportWebsiteUname, self.reportWebsitePass, self.webReportDetailsArr);
        self.editObjLoaded = true;
      }
      if (!self.updateModal) {
        self.resetPopUp();
      }
    },
    getInvestigationId() {
      var self = this;
      //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>1");
      if (self.show_modal && "27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27" && !self.toBeUploadObjLoaded) {
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>2");
        self.encounter_id = self.encounterid;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>3");
        self.reportType = "All";
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>4");
        self.testType = "X-Ray Barium Follow Through";
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>5");
        self.diagnostic_center_name = self.diagnosticcentername;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>6");
        self.tenantId = self.tenantid;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>7");
        self.$store.state.helper.max_report_file_count = parseInt(self.maxreportfilecount,10);
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>8");
        self.$store.state.helper.max_web_report_count = parseInt(self.maxwebreportcount,10);
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>9");
        
        //HANDLE THE CALCULATION here****
        self.webreportcountcanbeuploaded = parseInt(self.webreportcanbeuploaded,10)-this.webReportDetailsArr.length;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>10");
        self.filecountcanbeuploaded = parseInt(self.filescanbeuploaded,10);
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>11");

        
        if (self.selectedTestType) {
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>16");
          self.selected_test_type.test_name = "X-Ray Barium Follow Through";
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>17");
          self.selected_test_type.selected = true;
          //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>18");
        }
        self.toBeUploadObjLoaded = true;
        //console.log("parentproperty>>>getInvestigationId>>>self.reportType>>>>>self.testType>>>19>>","27fa6be4-0685-4caf-87f4-a82786ee32eb_76dbd6b2-d917-4e66-a68c-cef35935bf27",self.reportType,self.testType);
        //alert(self.encounter_id);
      }
    },
    getDownloadUrl() {
      if (
        this.gett_downloadfileUrl &&
        this.gett_downloadfileUrl.length > 0 &&
        this.gett_downloadfileUrl.indexOf(
          "documents-gen-ehr-dev.s3.amazonaws.com"
        )
      ) {
        if (this.viewItem & !this.downLoadItem) {
          this.fileUrl = this.gett_downloadfileUrl;
          //console.log("View URL-->", this.gett_downloadfileUrl);
          window.open(this.fileUrl, "_blank", "channelmode=1");
          this.viewItem = false;
          this.downLoadItem = false;
        }
        if (!this.viewItem & this.downLoadItem) {
          this.fileUrl = this.gett_downloadfileUrl;
          //console.log("Download URL-->" + this.gett_downloadfileUrl);
          // var ifrm = document.createElement("iframe");
          // ifrm.setAttribute("src", this.fileUrl);
          // ifrm.style.width = "100px";
          // ifrm.style.height = "100px";
          // ifrm.style.display="none";
          // document.body.appendChild(ifrm).click();
          // var anchor = document.createElement('a');
          // anchor.setAttribute("download", true);
          // anchor.setAttribute("href", this.fileUrl);
          // anchor.click();
          // let blob = new Blob([this.fileUrl], { type: 'image/jpeg' });
          // let link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = true;
          // link.click();
        }
      }
    },
    //After getting the File Upload key, then Save the data into the database
    getUploadedFileNames() {
      var self = this;
      if (
        self.gett_uploadedfile &&
        self.gett_uploadedfile.indexOf(self.stringToBeCropped) !== -1 &&
        self.uploadFlag === true
      ) {
        var tem = self.gett_uploadedfile;
        if (tem) {
          if (self.selected_reportSubmitMethod === "_desktop") {
            //first upload the file
            //console.log("In getUploadedFileNames--------->>>");
            self.CustomerTestReportsModel = {
              customer_Id: self.modifiedById,
              encounter_Id: " ", //this needs to be a space or any string value
              report_type: self.reportType,
              test_type: self.testType,
              created_date: new Date().toISOString(),
              modified_date: new Date().toISOString(),
              created_userid: self.modifiedById,
              report_actual_name: self.tempFiles,
              report_user_friendly_name: self.tempFiles,
              report_file_key: self.stringToBeCropped + self.tempFiles,
              report_notes: self.report_notes ? self.report_notes : "",
              tenant_id: self.tenantId
            };
            //setTimeout(() => {
            //console.log(self.CustomerTestReportsModel);
            //s3api.ac_patient_web_reports_save(self.CustomerTestReportsModel,self.tenantId);
            //},0);
            self.uploadFlag = false;
            //self.CustomerViewModel.unshift(self.CustomerTestReportsModel);
          }
          //If Save & continue don't close the popup, instead reset it.
          if (this.saveType === "save-reset") {
            this.resetPopUp();
          }
        }
      }
    },
    //Get All reports
    getReportDetails() {
      if (
        this.gett_patient_reports &&
        (this.gett_patient_reports.hasOwnProperty("unique_id") ||
          this.gett_patient_reports.length > 0) &&
        !this.deleteFlag
      ) {
        ////console.log("<<<<<<<<<<<>>>>>>>>>>>>>");
        ////console.log(this.gett_patient_reports);
        if (Array.isArray(this.gett_patient_reports) === true) {
          this.CustomerViewModel = this.gett_patient_reports;
        } else if (Array.isArray(this.gett_patient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_patient_reports);
        }
        //alert(this.saveType);
        if (this.saveType !== "save-reset") {
          this.closePopUp("fileReport");
        } else {
          this.resetPopUp();
        }
        //else{
        //var temp = this.selected_reportSubmitMethod;
        //this.resetPopUp();
        //this.selected_reportSubmitMethod = temp;
        //}
      }
    },
    getUpdatedStatus() {
      if (this.gett_updatedPatient_reports && this.updateFlag == true) {
        if (Array.isArray(this.gett_updatedPatient_reports) === true) {
          this.CustomerViewModel = this.gett_updatedPatient_reports;
        } else if (Array.isArray(this.gett_updatedPatient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_updatedPatient_reports);
        }
        this.$store.state.helper.showUpdatedAlertPopUp = true;
        this.updateFlag = false;
        if (this.updateType !== "update-reset") {
          this.closePopUp("editReport");
          this.resetPopUp();
        } else {
          var temp = this.selected_reportSubmitMethod;
          this.resetPopUp();
          this.selected_reportSubmitMethod = temp;
        }
      }
    },
    getDeletedStatus() {
      if (this.gett_deletedPatient_reports && this.deleteFlag) {
        if (
          Array.isArray(this.gett_deletedPatient_reports) === true &&
          this.gett_deletedPatient_reports.length > 0
        ) {
          this.CustomerViewModel = this.gett_deletedPatient_reports;
        }
        if (
          Array.isArray(this.gett_deletedPatient_reports) === true &&
          this.gett_deletedPatient_reports.length == 0
        ) {
          this.CustomerViewModel = [];
        } else if (Array.isArray(this.gett_deletedPatient_reports) === false) {
          this.CustomerViewModel.unshift(this.gett_deletedPatient_reports);
        }
      }
    }
  },
  watch: {
    /**
      // selected_reportSubmitMethod: function() {
      //   if (this.selected_reportSubmitMethod == "_desktop") {
      //       alert(this.selected_reportSubmitMethod);
      //   }
      //   else if(this.selected_reportSubmitMethod == "_web"){
      //       if(this.reportWebsiteUrl){
      //         if(this.reportWebsiteUrl.length==0)
      //         {
      //           this.disabledWebUrl = false;
      //         }
      //         else
      //         {
      //           this.disabledWebUrl = true;
      //         }
      //       }
      //       if(this.reportWebsiteUname){
      //         if(this.reportWebsiteUname.length==0)
      //         {
      //           this.disabledWebUserName = false;
      //         }
      //         else
      //         {
      //           this.disabledWebUserName = true;
      //         }
      //       }
      //       if(this.reportWebsitePass){
      //         if(this.reportWebsitePass.length==0)
      //         {
      //           this.disabledWebPass = false;
      //         }
      //         else
      //         {
      //           this.disabledWebPass = true;
      //         }
      //       }
      //   }
      // },
     
    
    reportWebsiteUrl: function() {
      if (this.selected_reportSubmitMethod == "_web") {
        if (this.reportWebsiteUrl) {
          if (this.reportWebsiteUrl.length != 0) {
            this.validWebUrl = this.isValidURL(this.reportWebsiteUrl);
          }
        }
        if (this.reportWebsiteUname) {
          if (this.reportWebsiteUname) {
            this.disabledWebUserName = false;
          } else {
            this.disabledWebUserName = true;
          }
        }
        if (this.reportWebsitePass) {
          if (this.reportWebsitePass.length == 0) {
            this.disabledWebPass = false;
          } else {
            this.disabledWebPass = true;
          }
        }
      }
    },
    reportWebsiteUname: function() {
      if (this.selected_reportSubmitMethod == "_web") {
        if (this.validWebUrl) {
          if (this.reportWebsiteUname) {
            if (
              this.reportWebsiteUname.length < this.minWebReportUsernameLength
            ) {
              this.validWebUserName = false;
            } else {
              this.validWebUserName = true;
            }
          }
        }
      }
    },
    reportWebsitePass: function() {
      if (this.selected_reportSubmitMethod == "_web") {
        if (this.validWebUrl && this.validWebUserName) {
          if (this.reportWebsitePass) {
            if (this.reportWebsitePass.length < this.minWebReportPassLength) {
              this.validWebUserPass = false;
            } else {
              this.validWebUserPass = true;
            }
          }
        }
      }
    },*/
    show_modal: function(val, oldVal) {
      if (val) {
        ////console.log("In Updated--->investigationid",this.parentObj);
      }
    },
    fileNamesSuccessfullyUploadedArr: function(val, oldVal) {
      if (val.length > 0) {
        //console.log("fileNamesSuccessfullyUploadedArr>>>val ", val);
        //console.log("fileNamesSuccessfullyUploadedArr>>>OldVal ", oldVal);
      }
    }
  },
  updated() {    
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({container: 'body'});
      $('body').tooltip({ selector: '[data-toggle="tooltip"]' }).click(function () {
          $('[data-toggle="tooltip"]').tooltip("hide");
      });
    });
  }
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease-in-out;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: opacity 0.5s ease-in-out;

}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* Upload report css 9-4-19*/
.modal-dialog.wider-upload {
  max-width: 700px !important;
  width: 700px;
  background: #ffffff;
  border-radius: 3px;
  height: auto;
}
.modal-dialog.wider-upload .modal-body {
  padding: 10px 100px 30px 100px;
}
/*INPUT*/
.container-comm input {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
.container-comm input:focus {
  box-shadow: none;
  outline: none;
  border-color: #0056e0 !important;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.container-comm input:focus ~ label {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #0056e0 !important ;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}
.container-comm input:valid ~ label {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #0056e0;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}
.container-comm input:valid ~ label {
  color: #606060;
}
.container-comm.grey.disable label.disable {
  top: -10px;
  font-size: 12px;
  left: 10px;
}
.container-comm.grey.disable input:disabled {
  color: #b9b9b9 !important;
}
.container-comm label {
  position: absolute;
  top: 10px;
  left: 20px;
  pointer-events: none;
  color: #606060;
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.container-comm .height-dft span.modal-mobile {
  display: none;
}
.container-comm input:focus ~ .height-dft span.modal-mobile,
.container-comm input:valid ~ .height-dft span.modal-mobile {
  display: block !important;
  font-size: 12px;
  color: #0056e0;
  font-weight: 500;
  margin-top: 0px;
  margin-left: -52px;
}
.container-comm.grey input,
.container-comm.grey label {
  background: #f8f9fb !important;
}
/*ERROR*/
.error-msg-hold input {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #f3453a !important;
  padding-left: 15px;
  font-size: 14px !important;
  font-weight: 500 !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
.error-msg-hold input:focus,
.error-msg-hold input:valid {
  box-shadow: none;
  outline: none;
  border-color: #f3453a;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.error-msg-hold input:focus ~ label,
.error-msg-hold input:valid ~ label {
  top: -10px;
  font-size: 12px;
  color: rgba(243, 69, 58, 1) !important;
  font-weight: 400;
  background: #fff;
  left: 10px;
  padding: 0 5px;
}
.error-msg-hold label {
  position: absolute;
  top: 10px;
  left: 20px;
  pointer-events: none;
  color: rgba(243, 69, 58, 0.8);
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.error-msg-hold .error {
  display: block;
  font-size: 12px;
  color: rgba(243, 69, 58, 0.8);
  font-weight: 500;
}
.error-msg-hold input:focus ~ span.error,
.error-msg-hold input:valid ~ span.error {
  display: block !important;
  font-size: 12px;
  color: rgba(243, 69, 58, 0.8);
  font-weight: 500;
  margin-top: 4px;
}
/* .error-msg-hold input:focus,
.error-msg-hold input:valid {
  border-color: rgba(243, 69, 58, 1) !important;
} */
span.error {
  display: none;
}
.error-msg-hold span.error {
  color: rgba(243, 69, 58, 0.8);
  display: block !important;
}

/*TEXTAREA*/
.container-TXT {
  position: relative;
}
.container-TXT textarea {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 80px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  margin-bottom:20px;
}
.container-TXT textarea:focus {
  box-shadow: none;
  outline: none;
  border-color: #0056e0 !important;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  padding-top: 10px;
}
.container-TXT textarea:valid {
  box-shadow: none;
  outline: none;
  border-color: #eaebed;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  padding-top: 10px;
}
.container-TXT textarea:valid {
  color: #606060;
}
.container-TXT textarea:focus ~ label {
  top: -10px;
  font-size: 12px !important;
  color: #0056e0 !important;
  font-weight: 400;
  background: #fff;
  width: auto;
  padding: 0 5px;
  left: 10px;
}
.container-TXT textarea:valid ~ label {
  top: -10px;
  font-size: 12px !important;
  color: #0056e0;
  font-weight: 400;
  background: #fff;
  width: auto;
  padding: 0 5px;
  left: 10px;
}
.container-TXT textarea:valid ~ label {
  color: #606060;
}
.container-TXT label {
  position: absolute;
  top: 12px;
  left: 20px;
  pointer-events: none;
  color: #606060;
  font-size: 14px;
  font-weight: 300 !important;
  font-weight: lighter;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Poppins', sans-serif !important;
}

.text-2000 {
  position: absolute;
  right: 0;
  top: -17px;
  color: #0056e0;
  font-size: 13px;
  font-weight: 500;
}

/*SELECT*/
.mart-spacer {
  margin-top: 58px !important;
}
.mart-spacermr {
  margin-top: 70px !important;
}
.wrap-hold {
  position: relative !important;
  margin-top: 7px;
}
.col-md-12.wrap-hold {
  padding: 0;
  margin: 0;
}
.wrap {
  position: absolute;
  right: 0;
  top: 0px;
  width: 100%;
  left: 0;
  margin: 0 0 0 0px;
  height: 45px;
  padding: 0 15px !important;
}
.wrap select {
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  height: 40px !important;
}
.select {
  font-family: "Poppins", sans-serif !important;
  position: relative;
  width: 100%;
}
.select-text {
  position: relative;
  font-family: inherit;
  background-color: transparent;
  width: 100%;
  padding: 10px 34px 10px 12px;
  font-size: 14px;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  font-weight: 400 !important;
}
/* Remove focus */
.select-text:focus {
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0) !important;
}
/* Use custom arrow */
.select .select-text {
  appearance: none;
  -webkit-appearance: none;
  color: #111 !important;
}
.select-text.show-first option:first-child {
  display: block;
}
.select:after {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  padding: 4px;
  content: "";
  pointer-events: none;
  background: #ffffff url(../../static/images/arrow-down.png) 0px 0px no-repeat;
}
.select-text:focus {
  border: solid 1px #0056e0 !important;
}
.select-label {
  color: #606060 !important;
  font-size: 14px;
  font-weight:400 !important;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 10px;
  transition: 0.2s ease all;
}

.select-text:focus ~ .select-label {
  color: #0056e0 !important;
  top: -10px;
  transition: 0.2s ease all;
  background: #ffffff;
  font-size: 12px;
  width: auto;
  padding: 0 5px;
  left: 10px;
}
.select-text:valid ~ .select-label {
  color: #0056e0 !important;
  top: -10px;
  transition: 0.2s ease all;
  background: #ffffff;
  font-size: 12px;
  width: auto;
  padding: 0 5px;
  left: 10px;
}
.select-text:valid ~ .select-label {
  color: #606060 !important;
}
.select-text:focus ~ .select-label {
  color: #0056e0 !important;
}
.select-text:focus ~ .select-bar:before,
.select-text:focus ~ .select-bar:after {
  width: 50%;
}
.select-highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 33.33% !important;
  float: left;
}
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.radio-container .radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border-radius: 50%;
  border: solid 3px #c6c6c6;
}
.radio-container:hover input ~ .radio-checkmark {
  background-color: #ffffff;
}
.radio-container input:checked ~ .radio-checkmark {
  background-color: #c6c6c6;
}
.radio-container .radio-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.radio-container input:checked ~ .radio-checkmark:after {
  display: block;
}
.radio-container .radio-checkmark:after {
  top: 0px;
  left: 0px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #0056e1;
}

.modal-dialog.wider-upload .modal-header {
  border-bottom: none;
  padding: 0;
  margin: 0;
}
.modal-dialog.wider-upload .modal-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 17px;
}

.modal-dialog.wider-upload .close.up-close {
  color: #8a8a8a !important;
  font-size: 28px;
  font-weight: 300;
  opacity: 1 !important;
  outline: none;
  position: relative;
  right: 12px;
  top: 8px;
}
.modal-dialog.wider-upload .close.up-close:active,
.modal-dialog.wider-upload .close.up-close:focus {
  color: #111 !important;
}

.row.choose-select-hold {
  width: 100%;
  /* display: none; */
  padding: 0;
  margin: 0 0 10px;
}
.web-repo-hold {
  width: 100%;
  /* display: none; */
  padding: 0;
  margin: 10px 0;
}
.add-category-section {
  position: relative;
}
.add-category-btn {
  position: absolute;
  bottom: -20px;
  right: 0px;
  width: 26px !important;
  height: 20px !important;
  padding: 0px !important;
  min-width: 26px;
}

a.add-category-btn span:first-of-type {
  top: 25%;
  bottom: 25%;
  width: 10%;
  left: 45%;
}
a.add-category-btn span:last-of-type {
  left: 25%;
  right: 25%;
  height: 10%;
  top: 45%;
}
a.add-category-btn span {
  position: absolute;
  transition: 0.3s;
  background: white;
  border-radius: 2px;
}

a.add-category-btn.open span:last-of-type {
  left: 50%;
  right: 50%;
}
a.add-category-btn.open span:last-of-type {
  transform: rotate(90deg);
}

a.add-category-btn.open span:first-of-type,
a.add-category-btn.open span:last-of-type {
  transform: rotate(90deg);
}

.add-category-part.mart-25.inline-add.clearfix {
  position: relative;
  width: 100%;
  padding: 0 15px;
  top:60px;
  margin-bottom: 50px;display: block;
}

.web-repo-hold {
  width: 100%;
  padding: 0 15px;
  margin: 0 0;
}
.row.wd-100 {
  width: 100%;
  margin-top: 20px;
}

 

.tags-hold ul {
  padding: 0;
  margin: 0;
}

.tags-hold ul li {
  float: left;
  list-style: none;
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 5px 30px 5px 10px;
  background: #0056e0;
  border-radius: 50px;
  position: relative;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
  cursor: default;
  width: auto;
  margin-top:1px;color:#fff;
}

.tags-hold ul li a {
    position: absolute;
    top: 2px;
    right: 10px;
    color: #fff;
    font-size: 20px;
}
.tags-hold ul li a i {
  font-size: 20px;
  color: #c2c4c5;
}

/* .select-file-holder input[type='file'] {color: transparent;} */
.select-file-holder {
  width: 98px;
  float: left;
}
.pdr-r10 {
  margin-right: 10px;
}
.row.wd-100 .col-md-12 {
  padding-right: 0px;
}

.custom-file-input {
  opacity: 1 !important;
  outline: none !important;
}
.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-file-input::file-upload-button {
  visibility: hidden;
}
.custom-file-input::before {
  content: "Choose file";
  display: inline-block;
  background: #ffffff;
  border: 1px solid #d7d7d7;
  border-radius: 0px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 500;
  font-size: 13px;
}
.custom-file-input:hover::before {
  background: #f9f9f9;
}
.custom-file-input:active::before {
  background: #ffffff;
}
.upload-outer p {
  font-weight: 500;
}

.file-upload.btn.btn-default {
  border: 1px solid #0056e0 !important;
  border-radius: 0px !important;
  float: none;
  margin:10px 0 0  0 !important ;
  padding: 8px 16px;
  background:#0056e0;
}
.info-upload {
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border:0px solid rgba(0, 86, 225, 0.5);
  padding: 5px 5px 5px 32px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;
  font-weight:400;
  position:relative;
}
.file-upload {
  position: relative;
  overflow: hidden;
  margin: 10px;
}
.file-upload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}
.file-upload.btn.btn-default span {
  font-size: 14px;
  color: #FFF;
  font-weight: 600;
}
/*SPAN*/
.container-comm span {
  display: block;
  width: 100% !important;
  background: #ffffff !important;
  height: 40px !important;
  border: none !important;
  border: solid 1px #d2d4d5 !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1d1d1d !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  padding: 10px 15px;
}
.container-comm .valid {
  top: -10px;
  left: 10px;
  font-size: 12px !important;
  color: #606060;
  font-weight: 400;
  width: auto;
  padding: 0 5px;
  background: #ffffff;
}

.add-notes-hold #add_category {
    margin: 0 0;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
}

.add-new-btn, .investi-clear-btn {
    float: right;
    padding: 15px;
    position: relative;
    padding-right: 40px;
    width: 100%;
    text-align: right;
    font-weight: 500;
}

.add-new-btn{margin-right:7px;}

.add-notes-hold .material-icons {
    float: left;
    margin: 0 0;
    top: -1px;
    right: 8px;
    padding: 0 0;
}

.add-new-btn i {
    color: #66696f;
    position: absolute;
    top: 13px;
    right: 15px;
}

#add_investigation .material-icons.open, #add_category .material-icons.open {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.error-upl{position: absolute; bottom:-20px; left:20px; font-size: 12px; font-weight: 500;}
.filename{    float: left;    width: calc(100% - 35px);padding-top:10px;}
    .timehold{font-size: 11px;padding: 0 8px ;float: left;width: 100%;}

.add-new-btn.add-updatedbtn{padding: 0px; padding-right: 30px; margin-right:0px;}
.add-new-btn.add-updatedbtn i{top: 0px; right: 0px;}
.primary-btn.add-category-btn span{padding: 0px 5px;}
.info-upload:before {
    width: 32px;
    height: 24px;
    position: absolute;
    display: block;
    content: "";
    left: 0;
    background: url(../../static/images/dashboard-newicons.png) no-repeat;
    background-position:0px -897px;
}

.container-comm .add-category-btn.add-dcn span{
    height: initial !important;
    background: transparent !important;
    border: none !important;
    color: #FFF !important;
}

.parenthold {
    position: relative;
}

.add-user-btn{background: #0056e0;  color: #fff;
    font-size: 20px;  position: relative;   top: -14px; float: right;  outline: 0;}

.add-user-btn, .remove-btn{border: 1px solid #0056e0;
    padding: 1px 6px 0 6px;
    line-height: 20px;
    height: 24px;
    width: 24px;
    right: 0;}

    .remove-btn{
    background: transparent;
    color: #0056e0;
    font-size: 16px;
    position: absolute;
    bottom: -10px;
    font-weight: 500;
}

#weburlsection:last-of-type .remove-btn {
    right: 24px;
}

.primary-btn.add-category-btn.add-dcn.h24-btn{height:24px !important; width: 24px !important; bottom: -23px; min-width: 24px;}
.primary-btn.add-category-btn.add-dcn.h24-btn span{font-size: 18px !important;}
.add-new-btn.addnote-inline {padding: 0;}
.add-new-btn.addnote-inline i.material-icons {top:-1px; right: -28px;}
.modal-mask.upl-hold .modal-header{border-bottom:0px solid transparent;}

.modal-mask:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }


.modal-wrapper {
  display: inline-block;
  text-align:left;
  vertical-align: middle;
  width: 100%;
}

.info-upload-mail {
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border:0px solid rgba(0, 86, 225, 0.5);
  padding: 5px 5px 5px 28px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;
  font-weight:400;
  position:relative;
}

.info-upload-mail:before {
    width: 24px;
    height: 24px;
    position: absolute;
    display: block;
    content: "";
    left: 0;
    background: url(../../static/images/dashboard-newicons.png) no-repeat;
    background-position:-57px -899px;
}

.alert-maxfiles{background-color: #FFF; border-radius:4px; border:0px solid #f5c6cb; width:100%; padding: 0 8px;
    margin: 10px 0 0px 0;
    float: left;
    margin-left: -35px;}
.alert-red1alert-maxfiles p{color: rgba(243, 69, 58, 0.8); }
.alert-maxfiles p::before{width: 24px; height: 24px; position: relative; display: block; content: ""; left:0px; float:left;
    background: url(../../static/images/dashboard-newicons.png) no-repeat; background-position: -117px -1051px;}

.info-upload-i {
  position: relative;
  width: 100%;
  display: block;
  float: left;
  background: rgba(0, 86, 225, 0);
  border:0px solid rgba(0, 86, 225, 0.5);
  padding: 5px;
  margin: 0px;
  font-size: 14px;
  color: #0056e1;
  text-align: left;padding-left: 30px;
  font-weight: 400;
}
.info-upload-i:before{
  width:28px;height: 28px;
  position: absolute; display:block;
  content: "";left:0;background: url(../../static/images/material_co_icon-new.png) no-repeat; 
  background-position:-122px -846px; top:4px;
}
.alert-red1 {
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid #f5c6cb;
    width: 100%;
    padding: 8px;
    margin: 0 0 15px 0;
    float: left;
}

.alert-red1 p {
    color: rgba(243, 69, 58, 0.8);
    text-align: center;
}

.alert-red1 p::before {
    width:24px;
    height:24px;
    position:relative;
    display:block;
    content: "";
    left:26px;
    float:left;
    background:url(../../static/images/dashboard-newicons.png) no-repeat;
    background-position:-56px -900px;
    top:1px;
}
.clinicalnote.modal-container.wider-midB{width:600px;}
.alert-red1.L-inline p::before{left:42px; top:1px;}
.error-info{color: rgba(243, 69, 58, 0.8) !important;}
.clinicalnote.modal-container.wider-midB .close.up-close{position: absolute;right: 20px;    top: 12px;}
.clinicalnote.modal-container.wider-midB .black-text{    color: #000;    padding: 0 0 0 15px;    display: inline-block;}
.col-md-12.text-center.file-detail-hold {    border: 1px solid #ececec;    background: #f4f4f4;    padding:20px 15px;    margin-bottom: 15px;float:left;MAX-HEIGHT: 144px;    overflow-y: auto;}
.col-md-12.text-center.file-detail-hold .Upload report{min-height: 30px;}
.tags-hold .list:Empty{background:url(../../static/images/imgpsh_fullsize_anim.png) no-repeat;min-height:40px;background-position: center;}
.file-upload.btn.btn-default:hover{    background: #0043a4;    color: #ffffff;    text-decoration: none;    border-color: #0043a4;    outline: none;}
.analysize.modal {
  z-index: 99999 !important;
}
.analysize .modal-body ul {
    padding-left: 15px;
}
.analysize .modal-body ul li {
    list-style: disc;
    margin-bottom: 5px;
}
.analysize .modal-body {
  padding:30px;
}
.analysize .modal-body h4 {
  font-weight:600;
  margin-bottom:15px;
}
.analysize .modal-body p, .analysize .modal-body ul li {
  font-size:16px
}
.analysize-loading .loader-line {
            width: 200px;
            height: 3px;
            position: relative;
            overflow: hidden;
            background-color: #ddd;
            margin:0;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
        }

        .analysize-loading .loader-line:before {
            content: "";
            position: absolute;
            left: -50%;
            height: 3px;
            width: 40%;
            background-color:#0056e0;
            -webkit-animation: lineAnim 1s linear infinite;
            -moz-animation: lineAnim 1s linear infinite;
            animation: lineAnim 1s linear infinite;
            -webkit-border-radius: 20px;
            -moz-border-radius: 20px;
            border-radius: 20px;
        }

        @keyframes lineAnim {
            0% {
                left: -40%;
            }
            50% {
                left: 20%;
                width: 80%;
            }
            100% {
                left: 100%;
                width: 100%;
            }
        }
        .analysize-loading {
    clear: both;
    display: flex;
    align-items: center;
    justify-content: center;
    padding:15px 0 10px;
}
.analysize-loading:after {
    content: "Analising";
    position: absolute;
    margin: -40px 0 0;
    color: #000;
    font-weight: 500;
    font-size: 15px;
}

.analysize-loading .uploaded, .analysize-loading .report {
    width: auto;
    height: auto;
    background:none;
    border-radius: 0;
     display: flex;
     align-items: center;
    justify-content: center;
    font-weight: 500;
    color: #0056e0;
    padding:0 15px;
}
.analysize .modal-dialog.modal-dialog-centered {
    margin-top: 1.75rem;
}
.upload-reports-section{
  padding: 0;
}
.ehr-popup-header-colored {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 22px;
    flex-shrink: 0;
}
.ehr-popup-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1E293B;
}
.ehr-popup-header-colored .ehr-popup-title {
    color: #fff;
    font-size: 15px;
}
.ehr-popup-header-colored .ehr-popup-title svg {
    color: rgba(255,255,255,0.8);
}
.ehr-popup-header-colored .ehr-popup-close {
    color: rgba(255,255,255,0.8);
    font-size: 22px;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 6px;
    padding: 4px 10px;
    cursor: pointer;
    line-height: 1;
}
.ehr-popup-close {
    font-size: 22px;
    color: #64748B;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    line-height: 1;
    transition: background 0.15s;
}
.popup-header-blue {
    background: linear-gradient(135deg, #0056D2 0%, #1273EB 100%);
}
.av-btn-ghost {
    background: #fff;
    color: #64748B;
    border: 1px solid #E2E8F0;
    border-radius: 7px;
    padding: 9px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.av-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: #1273EB;
    color: #fff;
    border: none;
    border-radius: 7px;
    padding: 9px 20px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    transition: background 0.15s;
}
.av-btn-ghost:hover {
    background: #F1F5F9;
    color: #334155;
}
.av-btn-primary:hover {
    background: #0056D2;
}
.model-foot{
    margin-bottom: 15px;
}
</style>